import React, { Component } from "react";
import "../style/category.scss";
import Pagination from "@material-ui/lab/Pagination";
import DeleteIcon from "../icon/DeleteIcon";
import * as GetCommentListAPI from "../apis/GetCommentListAPI";
import EditIcon from "../icon/EditIcon";
import AddComment from "../icon/AddComment";
import { getCategoryList } from "../apis/GetCategoryListAPI";
import { BASE_URL } from "../constants/ApiEndpointConstants";
import { deleteCategory } from "../apis/GetCategoryAPI";
import Loading from "./common/Loading";
import NoContent from "../icon/NoContent";
import moment from "moment";
import CloseIcon from "../icon/CloseIcon";
import SubmitIcon from "../icon/SubmitIcon";
import { setCategory } from "../apis/GetCategoryAPI";

class Category extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      per_page: 11,
      count: 1,
      categoryList: [],
      id: "",
      loadingShow: false,
      name: "",
      isShow: false,
    };
    this.handleGetCategoryList = this.handleGetCategoryList.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.delete = this.delete.bind(this);
    this.toggleShow = this.toggleShow.bind(this);
    this.changeName = this.changeName.bind(this);
    this.toggleAddShow = this.toggleAddShow.bind(this);
    this.add = this.add.bind(this);
    this.edit = this.edit.bind(this);
  }

  componentDidMount() {
    const { page, per_page } = this.state;
    this.handleGetCategoryList(page, per_page);
  }

  handleGetCategoryList(page, per_page) {
    getCategoryList(page, per_page).then((res) => {
      console.log(res);
      var status = res.status;
      if (status === 200) {
        var data = res.data.data;
        var total = data.total;
        let count = Math.ceil(total / per_page);
        this.setState({ count, categoryList: data.list });
      }
    });
  }

  handlePageChange(e, page) {
    this.setState({ page: page }, () => {
      this.handleGetCategoryList(page, this.state.per_page);
    });
  }

  add() {
    let { name, id } = this.state;
    if (name.trim() === "") return;
    setCategory(name, id).then((res) => {
      console.log(res);
      var data = res.data;
      if (data.msg === "success") {
        window.dispatchEvent(
          new CustomEvent("showAlert", {
            detail: "操作成功",
          }),
        );
      }

      this.setState({ name: "", isShow: false, id: "" });
      this.handleGetCategoryList(this.state.page, this.state.per_page);
    });
  }

  delete(id) {
    this.toggleShow();
    deleteCategory(id).then((res) => {
      this.toggleShow();
      var code = res.data.code;
      if (code === 1) {
        window.dispatchEvent(
          new CustomEvent("showAlert", {
            detail: "删除成功",
          }),
        );
        this.handleGetCategoryList(this.state.page, this.state.per_page);
      } else {
        window.dispatchEvent(
          new CustomEvent("showAlert", {
            detail: "操作失败",
          }),
        );
      }
    });
  }
  toggleShow() {
    this.setState({ loadingShow: !this.state.loadingShow });
  }

  changeName(e) {
    let value = e.target.value;
    this.setState({ name: value });
  }

  toggleAddShow() {
    this.setState({ isShow: !this.state.isShow });
  }

  edit(name, id) {
    this.setState({ name, id }, () => {
      this.toggleAddShow();
    });
  }

  render() {
    const { page, count, categoryList, name, isShow } = this.state;
    return (
      <React.Fragment>
        <Loading {...this.props} loadingShow={this.state.loadingShow} />
        {isShow && (
          <div className="add-box">
            <CloseIcon
              size={20}
              className="close"
              onClick={this.toggleAddShow}
            />
            <div className="row">
              <div className="title">分类名称</div>
              <input
                type="text"
                value={name}
                onChange={(e) => this.changeName(e)}
              />
            </div>
            <SubmitIcon
              size={20}
              className="submit"
              onClick={() => this.add()}
            />
          </div>
        )}

        <div className="category-page">
          <div className="toolbar">
            <AddComment
              size={30}
              color="#696cff"
              className="icon"
              onClick={this.toggleAddShow}
            />
          </div>
          <div className="content">
            <div className="li-header">
              <div className="left">
                <div className="name">NAME</div>
                <div className="time">TIME</div>
              </div>
              <div className="tool">OPERATION</div>
            </div>
            {categoryList.length > 0 ? (
              <React.Fragment>
                {categoryList.map((item, index) => {
                  return (
                    <div className="li" key={index}>
                      <div className="left">
                        <div className="name">{item.name}</div>
                        <div className="time">
                          {moment(item.createtime * 1000).format(
                            "YYYY-MM-DD HH:mm:ss",
                          )}
                        </div>
                      </div>
                      <div className="tool">
                        <EditIcon
                          size={16}
                          color="#696cff"
                          className="icon"
                          onClick={() => this.edit(item.name, item.id)}
                        />
                        <DeleteIcon
                          size={16}
                          color="#696cff"
                          className="icon"
                          onClick={() => this.delete(item.id)}
                        />
                      </div>
                    </div>
                  );
                })}
              </React.Fragment>
            ) : (
              <div className="no-content">
                {" "}
                <NoContent size={150} color="#707070" />
              </div>
            )}
          </div>
          <div className="footer">
            <Pagination
              count={count}
              page={page}
              onChange={this.handlePageChange}
              variant="outlined"
              color="standard"
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Category;
